// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Brim — seeds. The run (every orb's hidden brim + its jolt schedule) is a pure
// function of (mode, seed), so a seed is the whole shareable identity of a run: the
// daily gives everyone on Earth the same orbs, and an async seed-share lets a friend
// face the identical run and compare charges. In a live race the frozen seed is what
// keeps every peer's orbs byte-identical with nothing on the wire.

import { hashSeed, newSeed } from '@ben-gy/game-engine/rng';
import type { ModeId } from './modes';

export { newSeed };

/** Today's date in UTC as YYYY-MM-DD — the same string for every player on Earth. */
export function todayUTC(d: Date = new Date()): string {
  return d.toISOString().slice(0, 10);
}

/** The daily seed for a mode: identical worldwide, changes at UTC midnight. */
export function dailySeed(mode: ModeId, dateStr: string): number {
  return hashSeed(`brim:${mode}:${dateStr}`);
}

/** A short shareable code for a seed (base36), and its inverse. */
export function seedToCode(seed: number): string {
  return (seed >>> 0).toString(36).toUpperCase();
}

export function codeToSeed(code: string): number | null {
  const n = parseInt(code.trim().toLowerCase(), 36);
  return Number.isFinite(n) && n > 0 ? n >>> 0 : null;
}
